import { useLocation, Link } from 'react-router-dom';
import {
  CheckCircleIcon,
  EnvelopeIcon,
  KeyIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

export default function OnboardingSuccess() {
  const { state } = useLocation();

  const schoolData = state || {
    school: { name: 'Your School', code: 'SCH001' },
    admin: { email: 'admin@school.com', tempPassword: 'TempPass123' },
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6 py-20">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">

        {/* Success icon */}
        <div className="flex justify-center mb-4">
          <div className="w-14 h-14 rounded-full bg-green-100 text-green-600 flex items-center justify-center">
            <CheckCircleIcon className="w-8 h-8" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-center text-gray-800">
          School Created Successfully! 🎉
        </h1>

        <p className="text-center text-gray-500 text-sm mt-1">
          Your school is ready. Below are the admin credentials.
        </p>

        {/* School details */}
        <div className="mt-6 bg-gray-50 rounded-lg p-4 space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">School Name</span>
            <span className="font-medium text-gray-800">
              {schoolData.school?.name || 'N/A'}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-gray-500">School Code</span>
            <span className="font-medium text-gray-800 font-mono">
              {schoolData.school?.code || 'N/A'}
            </span>
          </div>
        </div>

        {/* Admin credentials */}
        <div className="mt-4 bg-gray-50 rounded-lg p-4 space-y-3">
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-500 flex items-center gap-1">
              <EnvelopeIcon className="w-4 h-4" /> Email
            </span>
            <span className="font-medium text-gray-800">
              {schoolData.admin?.email || 'N/A'}
            </span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-500 flex items-center gap-1">
              <KeyIcon className="w-4 h-4" /> Password
            </span>
            <span className="font-mono text-sm bg-gray-200 px-3 py-1 rounded">
              {schoolData.admin?.tempPassword || 'N/A'}
            </span>
          </div>
        </div>

        {/* Warning */}
        <div className="mt-4 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3 flex items-start gap-2">
          <span className="text-amber-500">⚠️</span>
          <span>Please change your temporary password after first login.</span>
        </div>

        {/* Changed to Pricing button */}
        <div className="mt-6 text-center">
          <Link
            to="/login"                    // ← Changed route
            className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition font-medium"
          >
            Let's Login
            <ArrowRightIcon className="w-4 h-4" />
          </Link>
        </div>

      </div>
    </div>
  );
}